import React, { useEffect } from "react";
import "./Overlay.css";
import { createPortal } from "react-dom";
import CloseIcon from "@mui/icons-material/Close";

const Overlay = ({
  images,
  onClose,
  ImagesComponent,
  bgGradient,
  title,
  desc,
}) => {
  useEffect(() => {
    document.documentElement.style.overflowY = "hidden";
    return () => {
      document.documentElement.style.overflowY = "auto";
    };
  }, []);

  return createPortal(
    <div className="overlayMain">
      <div className="overlay-content">
        <button
          className="close-button"
          onClick={() => {
            onClose();
          }}
        >
          <CloseIcon />
        </button>
        {bgGradient ? (
          <>
            <div
              // className="news-image"
              style={{
                // backgroundImage: bgGradient,
                // width: "100%",
                // maxWidth: 850,
                // aspectRatio: 3 / 2.5,
                backgroundRepeat: "no-repeat",
                borderRadius: 8,
                backgroundSize: "cover",
                backgroundPosition: "center",
                marginTop: "10vh",
              }}
            ></div>
            <div
              style={{
                color: "#fff",
                fontSize: "1.5em",
                fontWeight: "bold",
                textAlign: "center",
                paddingTop: 20,
              }}
            >
              {title}
            </div>
            <div className="news-content">
              <p
                // className="news-text"
                style={{
                  color: "white",
                }}
              >
                {desc}
              </p>
            </div>
          </>
        ) : ImagesComponent ? (
          <ImagesComponent />
        ) : images && images.length > 0 ? (
          <div className="overlay-images">
            {images.map((image, index) => (
              <div key={index} className="overlay-image">
                <img
                  src={image.src}
                  alt={image.text}
                  style={{
                    height: "70vh",
                  }}
                />
                <p
                  style={{
                    fontSize: "1.5rem",
                    fontWeight: "bold",
                  }}
                >
                  {image.text}
                </p>
              </div>
            ))}
          </div>
        ) : (
          <></>
        )}
      </div>
    </div>,
    document.body
  );
};

export default Overlay;
